import { StormSewerRun, Catchpit, Soakaway, PipeDiameterSummary } from '../types/tender.types';

export const calculateCatchpitVolume = (length: number, width: number, depth: number, count: number): number => {
  return length * width * depth * count;
};

export const calculateSoakawayVolume = (diameter: number, depth: number, count: number): number => {
  const radius = diameter / 2;
  const volume = Math.PI * radius * radius * depth;
  return volume * count;
};

export const calculateGullyConnectionLength = (gullyCount: number, standardLength: number = 6): number => {
  return gullyCount * standardLength;
};

export const calculatePipeDiameterSummaries = (pipeRuns: StormSewerRun[]): PipeDiameterSummary[] => {
  const summaryMap = new Map<string, { totalLength: number; count: number }>();

  pipeRuns.forEach(run => {
    const diameter = run.diameter;
    const length = run.length || 0;
    
    if (summaryMap.has(diameter)) {
      const existing = summaryMap.get(diameter)!;
      existing.totalLength += length;
      existing.count += 1;
    } else {
      summaryMap.set(diameter, { totalLength: length, count: 1 });
    }
  });

  return Array.from(summaryMap.entries())
    .map(([diameter, data]) => ({
      diameter,
      totalLength: data.totalLength,
      count: data.count
    }))
    .sort((a, b) => {
      // Sort by diameter size (numeric comparison)
      const aNum = parseInt(a.diameter.replace('mm', ''));
      const bNum = parseInt(b.diameter.replace('mm', ''));
      return aNum - bNum;
    });
};

export const calculateTotalStormLength = (pipeRuns: StormSewerRun[], includeGullyConnections: boolean = true): number => {
  return pipeRuns.reduce((total, run) => {
    let length = run.length || 0;
    if (includeGullyConnections && run.isGullyConnection && run.connectionLength) {
      length += run.connectionLength;
    }
    return total + length;
  }, 0);
};

export const validateCatchpit = (catchpit: Catchpit): string[] => {
  const errors: string[] = [];
  
  if (!catchpit.ref.trim()) {
    errors.push('Catchpit reference is required');
  }
  
  if (catchpit.length <= 0) {
    errors.push('Length must be greater than 0');
  }
  
  if (catchpit.width <= 0) {
    errors.push('Width must be greater than 0');
  }
  
  if (catchpit.depth <= 0) {
    errors.push('Depth must be greater than 0');
  }
  
  if (catchpit.count <= 0) {
    errors.push('Count must be greater than 0');
  }
  
  return errors;
};

export const validateSoakaway = (soakaway: Soakaway): string[] => {
  const errors: string[] = [];
  
  if (!soakaway.ref.trim()) {
    errors.push('Soakaway reference is required');
  }
  
  if (soakaway.diameter <= 0) {
    errors.push('Diameter must be greater than 0');
  }
  
  if (soakaway.depth <= 0) {
    errors.push('Depth must be greater than 0');
  }
  
  if (soakaway.count <= 0) {
    errors.push('Count must be greater than 0');
  }
  
  return errors;
};